"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function HeaderSecondaryNavigation({ children }) {
    return ((0, jsx_runtime_1.jsx)("ul", { className: "usa-nav__secondary-links", children: (0, uswds_react_utils_1.flattenChildren)(react_1.Children.toArray(children)).map((child) => {
            const el = child;
            return (0, react_1.cloneElement)(el, {
                secondary: true
            });
        }) }));
}
exports.default = HeaderSecondaryNavigation;
